import { render, staticRenderFns } from "./DashboardEcoImpact.vue?vue&type=template&id=08f59d90&scoped=true"
import script from "./DashboardEcoImpact.vue?vue&type=script&lang=js"
export * from "./DashboardEcoImpact.vue?vue&type=script&lang=js"
import style0 from "./DashboardEcoImpact.vue?vue&type=style&index=0&id=08f59d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f59d90",
  null
  
)

export default component.exports